import { render, staticRenderFns } from "./RegisterClient.vue?vue&type=template&id=f964b24e&"
import script from "./RegisterClient.vue?vue&type=script&lang=js&"
export * from "./RegisterClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports